<template>
	<div class="page__content">
		<div class="page__content__tools">
			<slot name="tools" />
		</div>
		<div class="page__content__content">
			<slot />
		</div>
		<hover-view style="z-index: 1000000;" v-if="$store.state.hoverType == 'task'" :value="$store.state.hover" :align="$store.state.hoverAlign" :types="_types" :departments="_departments" :employees="_employees" :instructions="_instructions" />
		<contact-hover-view style="z-index: 1000000;" v-if="$store.state.hoverType == 'contact'" :item="$store.state.hover" :align="$store.state.hoverAlign" />
	</div>
</template>

<script>
	import HoverView from '../views/HoverView'
	import ContactHoverView from '../views/ContactHoverView'

	export default {
		components: {
			HoverView,
			ContactHoverView
		},
		data() {
			return {
				types: [],
				departments: [],
				instructions: [],
				employees: []
			};
		},
		computed: {
			_types() {
				var r = {};

				for (var i = 0; i < this.types.length; ++i) {
					r[this.types[i].name] = this.types[i];
				}

				

				return r;
			},
			_departments() {
				var r = {};

				for (var i = 0; i < this.departments.length; ++i) {
					r[this.departments[i].id] = this.departments[i];
				}

				

				return r;
			},
			_instructions() {
				var r = {};

				for (var i = 0; i < this.instructions.length; ++i) {
					r[this.instructions[i].name] = this.instructions[i];
				}

				

				return r;
			},
			_employees() {
				var r = {};

				for (var i = 0; i < this.employees.length; ++i) {
					r[this.employees[i].id] = this.employees[i];
				}

				

				return r;
			}
		},
		created() {
			

			const self = this;

			this.axios
				.get('/tasks/types/')
				.then(function (r) {
					self.types = r.data._items;
				});

			this.axios
				.get('/employees/all/')
				.then(function (r) {
					self.employees = r.data._items;
				});

			this.axios
				.get('/us/departments/')
				.then(function (r) {
					self.departments = r.data._items;
				});

			this.axios
				.get('/tasks/instructions/')
				.then(function (r) {
					self.instructions = r.data._items;

					
				});
		}
	}
</script>

<style lang="scss">
	.page {
		&__content {
			position: absolute;
			left: 0;
			top: 81px;
			bottom: 0;
			width: 100%;
			overflow: visible;

			&__content {
				position: absolute;
				left: 0;
				top: 0;
				bottom: 0;
				width: 100%;
				overflow: auto;
				-webkit-overflow-scrolling: touch;
			}

			&__tools {
				position: absolute;
				top: -80px;
				right: 0;
				height: 80px;
				padding: 20px 20px 20px;

				& > * {
					margin-left: 10px;
					float: left;
				}
			}
		}
	}

	@media only screen and (max-width: 600px) {
		.page__content {
			top: 41px;
		}
	}

	@media only screen and (-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi) { 
		.page__content {
			top: 81px;
		}
	}
</style>